// extracted by mini-css-extract-plugin
export var container = "History-module--container--3aS9P";
export var timeline = "History-module--timeline--1NQ-v";